module.exports = __webpack_public_path__ + "media/activity-level/normal-fairly-active-b7ed1b44.svg";